import React from 'react';
import { BiddingView, CardValueView, ExamView } from '../../graphql/types.gen.ts';
import { IResult } from '../../pages/Game/Game.tsx';
import { BiddingUI } from '../BiddingUI/BiddingUI.tsx';
import Answer from './Answer.tsx';

interface BidProps {
	drawnTest: ExamView;
	userBid: BiddingView;
	bestAnswers: BiddingView[];
	handleUserBids: (b: BiddingView) => void;
	result: IResult;
	handleResult: (r: IResult) => void;
	drawTest: () => void;
	repeatTest: () => void;
	nextTest?: () => void;
	recentBids: BiddingView[];
	forLesson?: boolean;
	currentTestId?: string;
}
export const valueToPC = (value: CardValueView) => {
	switch (value) {
		case CardValueView.Ace:
			return 4;
		case CardValueView.King:
			return 3;
		case CardValueView.Queen:
			return 2;
		case CardValueView.Jack:
			return 1;
		default:
			return 0;
	}
};

export const Bids = (props: BidProps) => {
	const {
		recentBids,
		drawnTest,
		handleUserBids,
		result,
		userBid,
		bestAnswers,
		nextTest,
		drawTest,
		repeatTest,
		forLesson,
		currentTestId,
	} = props;

	const shouldShowComment = Math.floor(recentBids.length / 4) + 1 === drawnTest?.definition.answers.length;

	return (
		<div className="bid">
			{drawnTest?.name && <p className="cards__testName">#{drawnTest.name.toUpperCase()}</p>}
			{!result && <BiddingUI handleUserBids={handleUserBids} recentBids={recentBids} />}
			{result && (
				<div>
					<Answer
						comment={shouldShowComment ? drawnTest?.comment : ''}
						userBid={userBid}
						bestAnswers={bestAnswers}
						result={result}
						nextTest={nextTest}
						drawTest={drawTest}
						repeatTest={repeatTest}
						forLesson={forLesson}
						currentTestId={currentTestId}
					/>
				</div>
			)}
		</div>
	);
};
